import { IconAlertSuccessGreen } from '@hulu-react-style-components/icons';
import React from 'react';

import { EmptyIcon, StepName, Wrapper } from './styled';

type Props = {
  isCompleted?: boolean;
  stepName: string;
};

const ICON_SIZE = 20;

function BreadcrumbStep({ isCompleted = false, stepName }: Props): JSX.Element {
  return (
    <Wrapper>
      {isCompleted ? (
        <IconAlertSuccessGreen width={ICON_SIZE} height={ICON_SIZE} data-testid="completedIcon" />
      ) : (
        <EmptyIcon />
      )}
      <StepName variant="eyebrow">{stepName}</StepName>
    </Wrapper>
  );
}

export default BreadcrumbStep;
